export default __webpack_public_path__ + "static/ashwin-goyal-78f11b82be83abc49a7969b80586a3fb.png";